var React = require('react');

function ArrowCircleFillAngled (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"32","height":"32","rx":"16","fill":"black","key":0}),React.createElement("path",{"d":"M21 11L15.4232 12.4943L19.5057 16.5768L21 11ZM12.3536 20.3536L18.1716 14.5355L17.4645 13.8284L11.6464 19.6464L12.3536 20.3536Z","fill":"white","key":1})]);
}

ArrowCircleFillAngled.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = ArrowCircleFillAngled;

ArrowCircleFillAngled.default = ArrowCircleFillAngled;
